import { render, staticRenderFns } from "./EditManagement.vue?vue&type=template&id=0616b493&scoped=true&"
import script from "./EditManagement.vue?vue&type=script&lang=js&"
export * from "./EditManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0616b493",
  null
  
)

export default component.exports